export const MOBILE_PRIMARY_CTA_CLASS = [
  'w-full min-h-nav-cta px-4 rounded-xl text-sm font-bold leading-tight',
  'text-center text-white transition-all inline-flex items-center justify-center gap-2',
].join(' ');

export const MOBILE_PRIMARY_CTA_DISABLED_CLASS = 'bg-slate-300 cursor-not-allowed';
export const MOBILE_PRIMARY_CTA_ENABLED_CLASS = 'bg-brand cursor-pointer';
